import { AppState, UrlPartSerializer } from '@immosky/types';
import { TypedAction } from '@ngrx/store/src/models';
import { setRegionFiltersBasedOnUrl } from './region.actions';

export class RegionFilterSerializer implements UrlPartSerializer {
  constructor(public readonly key: string) {}

  deserialize(urlValue: string): TypedAction<string> {
    const regionIDs = urlValue
      .split(',')
      .map((v) => v.trim())
      .map((id) => parseInt(id))
      .filter((id) => !isNaN(id));

    return setRegionFiltersBasedOnUrl({
      regionIDs,
    });
  }

  serialize(state: AppState): string {
    const filter = state.filter.region.regions;
    return filter.map((region) => region.id).join(',');
  }
}
